/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function ChevronRightSmallIcon(props: IconProps) {
	const { color = 'white', className } = props;

	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="8"
			height="14"
			viewBox="0 0 8 14"
		>
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-827 -454)">
					<path d="M835 461.002c.005.149-.044.3-.156.414-.025.025-.062.019-.09.037l-6.823 6.384a.538.538 0 01-.77 0 .565.565 0 010-.787l6.467-6.05-6.468-6.051a.563.563 0 010-.786.538.538 0 01.77 0l6.822 6.38c.029.02.067.014.092.04a.555.555 0 01.155.419z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default ChevronRightSmallIcon;
